// extracted by mini-css-extract-plugin
export default {"wrapper":"Contact_wrapper__VvOYi","banner":"Contact_banner__zX10k","textWrapper":"Contact_textWrapper__xWFbw"};